var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.project,
      expression: "loading.project"
    }],
    attrs: {
      "title": "project"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "250px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "created_at", $$v);
      },
      expression: "payload.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "name", $$v);
      },
      expression: "payload.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Components count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.components_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "components_count", $$v);
      },
      expression: "payload.components_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Domain"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.subdomain,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "subdomain", $$v);
      },
      expression: "payload.subdomain"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Drafts count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.drafts_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "drafts_count", $$v);
      },
      expression: "payload.drafts_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Export code count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.export_code_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "export_code_count", $$v);
      },
      expression: "payload.export_code_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Archived"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_archived,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_archived", $$v);
      },
      expression: "payload.is_archived"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Locked"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_locked,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_locked", $$v);
      },
      expression: "payload.is_locked"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Enable SSL"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_force_ssl,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_force_ssl", $$v);
      },
      expression: "payload.is_force_ssl"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Meta enabled facebook"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_meta_enabled_facebook,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_meta_enabled_facebook", $$v);
      },
      expression: "payload.is_meta_enabled_facebook"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Meta enabled twitter"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_meta_enabled_twitter,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_meta_enabled_twitter", $$v);
      },
      expression: "payload.is_meta_enabled_twitter"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Overrides enabled"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_overrides_enabled,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_overrides_enabled", $$v);
      },
      expression: "payload.is_overrides_enabled"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Published"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_published,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_published", $$v);
      },
      expression: "payload.is_published"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Syncing"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_syncing,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_syncing", $$v);
      },
      expression: "payload.is_syncing"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "White label"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.payload.is_white_label,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "is_white_label", $$v);
      },
      expression: "payload.is_white_label"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Latest release plugin version"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.latest_release_plugin_version,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "latest_release_plugin_version", $$v);
      },
      expression: "payload.latest_release_plugin_version"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Live project release homepage slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.live_project_release_homepage_slug,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "live_project_release_homepage_slug", $$v);
      },
      expression: "payload.live_project_release_homepage_slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Page names"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: _vm.payload.page_names,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "page_names", $$v);
      },
      expression: "payload.page_names"
    }
  }, _vm._l(_vm.payload.page_names, function (item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Project members count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.project_members_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "project_members_count", $$v);
      },
      expression: "payload.project_members_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Revision count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.payload.revision_count,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "revision_count", $$v);
      },
      expression: "payload.revision_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Short ID"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.short_id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "short_id", $$v);
      },
      expression: "payload.short_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Webhooks URLS"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: _vm.payload.webhooks_urls,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "webhooks_urls", $$v);
      },
      expression: "payload.webhooks_urls"
    }
  }, _vm._l(_vm.payload.webhooks_urls, function (item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.slug,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "slug", $$v);
      },
      expression: "payload.slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Team name"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.payload.team_name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "team_name", $$v);
      },
      expression: "payload.team_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Team slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.payload.team_slug,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "team_slug", $$v);
      },
      expression: "payload.team_slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Thumb URL"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.payload.thumb_url,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "thumb_url", $$v);
      },
      expression: "payload.thumb_url"
    }
  }), _c('el-button', {
    attrs: {
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": function ($event) {
        return _vm.onCopy(_vm.payload.thumb_url);
      }
    }
  }, [_vm._v("Copy")])], 1), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.projectRelease,
      expression: "loading.projectRelease"
    }],
    attrs: {
      "label": "Canary download url web"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.payload.canary_download_url_web,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "canary_download_url_web", $$v);
      },
      expression: "payload.canary_download_url_web"
    }
  }), _c('el-button', {
    attrs: {
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": function ($event) {
        return _vm.onCopy(_vm.payload.canary_download_url_web);
      }
    }
  }, [_vm._v("Copy")])], 1), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.projectRelease,
      expression: "loading.projectRelease"
    }],
    attrs: {
      "label": "Download url web"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.payload.download_url_web,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "download_url_web", $$v);
      },
      expression: "payload.download_url_web"
    }
  }), _c('el-button', {
    attrs: {
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": function ($event) {
        return _vm.onCopy(_vm.payload.download_url_web);
      }
    }
  }, [_vm._v("Copy")])], 1), _c('el-form-item', {
    attrs: {
      "label": "Updated at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.payload.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "updated_at", $$v);
      },
      expression: "payload.updated_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": _vm.clearCache
    }
  }, [_vm._v("Clear server image cache")]), _c('el-link', {
    attrs: {
      "href": _vm.projectUrl,
      "target": "_blank"
    }
  }, [_vm._v("Open in Anima")]), _vm.sourceUrl ? _c('el-link', {
    attrs: {
      "href": _vm.sourceUrl,
      "target": "_blank"
    }
  }, [_vm._v("Open in Figma")]) : _vm._e(), _c('div', {
    staticClass: "confirm-buttons"
  }, [_vm.payload.is_deleted ? _c('Confirm', {
    on: {
      "confirm": _vm.restore
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Restore")])], 1) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }